<template lang="html">

  <div class="comentarios" v-if="comentarios.length > 0">
    <h6>{{$t('blog.titulo_comentarios')}}</h6>
    <div class="container-text">
      <comentario-el v-for="(comentario,key) in comentarios" :data="comentario" :key="key"></comentario-el>
    </div>
  </div>

</template>

<script lang="js">

  import comentario_el from '@/components/view-parts/ficha-blog/comentario-el'

  export default  {
    name: 'listado-comentarios',
    props: ['comentarios'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    components: {
      'comentario-el' : comentario_el
    }
  }
</script>

<style scoped>
.listado-comentarios {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/ficha-blog/listado-comentarios.vue